import { Page } from "components/Page";
import Consumer from "../features/consumer/Consumer";

export const FingerPrintPage = () => {
  return (
    <Page title="Consumer List">
      <Consumer />
    </Page>
  );
};
